/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useFormikContext, Field} from 'formik'
import {ReactCountryFlag} from 'react-country-flag'
import {MenuComponent} from '@/_metronic/assets/ts/components'
import {KTIcon} from '@/_metronic/helpers'
import {Product} from '../../core/_models'

const regions = [{
  code: 'EU',
  name: 'Europe',
}, {
  code: 'FR',
  name: 'France',
}, {
  code: null,
  name: 'Worldwide'
}]

const Regions: FC = () => {
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const {values, setFieldValue} = useFormikContext()
  const product = values as Product

  const currentRegion = regions.find((x) => x.code === product.region)
    return (
      <div className="mb-5">
        <Field
        name="region"
        id="region"
        type="hidden"
      />

      <label className="fw-bold fs-6 mb-2">Region</label>
      <button
        type="button"
        className='btn btn-light btn-sm ms-5'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        {product?.region ? (
          <ReactCountryFlag
            countryCode={product.region}
            style={{ fontSize: '1.5em' }}
            className='h-20px rounded-1 ms-2'
          />
        ) : (
          <i className="fa-solid fa-globe"></i>
        )}
        <span className="ms-2">{currentRegion?.name}</span>
        <KTIcon iconName='down' className='fs-5 m-0' />
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {regions.map((r, index) => (
          <div key={`region-${index}`}className='menu-item px-3'>
            <a className='menu-link px-3' onClick={() => setFieldValue('region', r.code)}>
              {r?.code !== null ? (
                <ReactCountryFlag
                  countryCode={r.code}
                  style={{ fontSize: '1.5em' }}
                  className='h-20px rounded-1'
                />
              ) : (
                <i className="fa-solid fa-globe pl-5"></i>
              )}
              <span className="ms-2">{r?.name}</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Regions}
